import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  TextField,
  Button,
  Typography,
  Grid,
  TextareaAutosize,
  DialogActions 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TextBoxWithCheckbox from './TextBoxWithCheckbox';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { styled } from '@mui/material/styles';
import AddAgendaPopup from './AddAgendaPopupNew';
import AddAPostPopup from './AddPostPopup';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    width: '90%',
    maxWidth: 'none',
    maxHeight: '90%',
    margin: 'auto',
    overflow: 'auto',
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));





const AddPopupComponent = ({title,data,setData,selectedSection }) => {
  const [open, setOpen] = useState(false);
 

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const renderPopupComponent = (selectedSection) =>{
    switch (selectedSection) {
      case 'Agenda':
        return <AddAgendaPopup setAgendas={setData} agendas={data} handleOpen={handleOpen} handleClose={handleClose} />
      case 'Posts':
        return <AddAPostPopup  setPosts={setData} posts={data} handleOpen={handleOpen} handleClose={handleClose} />
      default:
        return ''
    }
  } 

  return (
    <>
      <Button
        style={{ float: 'right' }}
        onClick={handleOpen}
        variant="contained"
      >
        {title}
      </Button>
      <BootstrapDialog
        open={open}
        onClose={handleClose}
        maxWidth="xs"
        PaperProps={{
          style: {
            borderRadius: 12,
            padding: '20px',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
            width: '90%',
          },
        }}
      >
        {renderPopupComponent(selectedSection)}
        
      </BootstrapDialog>
    </>
  );
};

export default AddPopupComponent;
